import {
  type AnalyticsSummary,
  type ClubActivity,
  type DemandSupply,
  type GrowthPoint,
  type MostSearched,
  type PlatformReport,
} from '@/contracts';

import { authenticated } from '../auth-client';
import { API_PREFIX } from '../http';

export const analyticsEndpoints = {
  analyticsSummary() {
    return authenticated<AnalyticsSummary>(`${API_PREFIX}/admin/analytics/summary`);
  },

  analyticsGrowth(months: number) {
    return authenticated<GrowthPoint[]>(`${API_PREFIX}/admin/analytics/growth?months=${months}`);
  },

  analyticsDemandSupply() {
    return authenticated<DemandSupply[]>(`${API_PREFIX}/admin/analytics/demand-supply`);
  },

  /** The specialties clubs search for most — for the Reports "top specialties" list. */
  analyticsMostSearched() {
    return authenticated<MostSearched[]>(`${API_PREFIX}/admin/analytics/most-searched`);
  },

  /** The most active clubs — profiles opened and candidates shortlisted. */
  clubActivity() {
    return authenticated<ClubActivity[]>(`${API_PREFIX}/admin/analytics/club-activity`);
  },

  report(from?: string, to?: string) {
    const params: Record<string, string> = {};
    if (from) params.from = from;
    if (to) params.to = to;
    const query = new URLSearchParams(params).toString();
    return authenticated<PlatformReport>(`${API_PREFIX}/admin/reports${query ? `?${query}` : ''}`);
  },

  /**
   * The window's report as a CSV file (UTF-8 with a BOM, so Excel keeps the Arabic
   * labels). Fetched with the bearer token and read as bytes rather than opened as a
   * plain link: a link would carry no token and get a 401.
   */
  reportExportCsv(from: string, to: string) {
    const query = new URLSearchParams({ from, to }).toString();
    return authenticated<Blob>(`${API_PREFIX}/admin/reports/export.csv?${query}`, {
      responseType: 'blob',
    });
  },
};
